import axios from "axios";

export default async function setOffer({ id, index, title, description }) {
    try {
        const res = await axios.put(
            `${process.env.REACT_APP_BACKEND_URL}/api/admin/offer`,
            { id, index, title, description },
            {
                withCredentials: true,
                validateStatus: () => true,
            }
        );

        return {
            ok: res.status >= 200 && res.status < 300,
            status: res.status,
            data: res.data,
        };
    } catch (err) {
        console.error("Erreur setOffer:", err);
        return { ok: false, status: 0, error: err.message };
    }
}
